import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Notice = ({
  type,
  title,
  icon,
  body,
  uniqueID,
  children,
}) => {
  const typeClass = type ? `Notice_${type}` : '';
  const hasOtherIcon = `Notice__Icon ${icon}`;

  return (
    <div
      className={classnames('Notice', typeClass)}
      id={uniqueID && uniqueID}
    >
      {title &&
        <div className="Notice_title">{title}</div>
      }
      <div className="Notice_content">
        {!type &&
           icon &&
           <div>
             <span className={hasOtherIcon} />
           </div>
        }
        {type &&
          <div >
            {type === 'success' &&
              <span className={icon ? hasOtherIcon : 'Notice__Icon glyphicon glyphicon-ok-sign'} />
            }
            {type === 'warning' &&
              <span className={icon ? hasOtherIcon : 'Notice__Icon glyphicon glyphicon-exclamation-sign'} />
              }
            {type === 'danger' &&
              <span className={icon ? hasOtherIcon : 'Notice__Icon glyphicon glyphicon-remove-sign'} />
            }
          </div>
        }
        {body && !children &&
          <div>
            {body}
          </div>
        }
        {children && !body &&
          <div className="Notice__content--body">
            {children}
          </div>
        }
      </div>
    </div>
  );
};

Notice.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  /** Body is being deprecated */
  body: PropTypes.any,
  children: PropTypes.any,
  icon: PropTypes.string,
  uniqueID: PropTypes.string,
};

Notice.defaultProps = {
  type: null,
  title: null,
  body: null,
  children: '',
  icon: null,
  uniqueID: null,
};

export default Notice;
